import { BlockTitle } from "@blocks/Blocks";

import TermsAndConditionsSection from "./TermsAndConditionsSection";
import WinnersCountSection from "./WinnersCountSection";

/**
 * Component to render Winners section for FAQ Page
 */
const WinnersSection = (): React.ReactElement => {
  return (
    <>
      <BlockTitle
        text="Winners & Prizes"
        rootClassName="bg-gray-150 lg:text-xl font-medium py-6 pl-4 font-poppins"
      />

      <WinnersCountSection />

      <TermsAndConditionsSection />
    </>
  );
};

export default WinnersSection;
